
<!-- 能源管理 -->
<template>
  <div class="emhome flex_row apphome">
    <!-- <leftcolumn class="app5760 flex_column"/> -->

    <div class="left flex_column">
      <div class="mybox">
        <div class="title">能源走势</div>
        <div class="box" style="overflow: visible">
          <EnergyTrend></EnergyTrend>
        </div>
      </div>
      <div class="mybox">
        <div class="title">能源结构</div>
        <div class="box">
          <EnergyStructure></EnergyStructure>
        </div>
      </div>
      <div class="mybox">
        <div class="title">重点用能设备<span @click="showImportDev" class="more el-icon-more"></span></div>
        <div class="box">
          <KeyEnergyEquipment></KeyEnergyEquipment>
        </div>
      </div>
      <div class="mybox">
        <div class="title">安全提示</div>
        <div class="box anquanlist">
          <li v-for="(item, index) in anquanList" :key="index" @click="pointClick(item.id)">
            <i class="el-icon el-icon-warning" :style="item.dengji==1?'color:#f95458':''"></i>
            <span>{{item.name}}</span>
            <span>{{item.type}}</span>
            <span>{{item.time}}</span>
          </li>
        </div>
      </div>
    </div>
    <div class="center flex_column">
      <div class="top">
        <div class="mybox">
          <div class="title">实时状态</div>
          <div class="box realtime" ref="iframeHeightPower">
            <div class="imgbox" :style="{height:iHeight+ 'px'}">
              <iframe v-if="configurationMap" width="100%" height="100%" :src="configurationMap" frameborder="0"></iframe>
              <img v-else src="@/assets/images/noZutai.png" alt="" class="noimg">
            </div>           
            <RealTimeStatus v-if="openWin" v-bind:deviceId="deviceId"></RealTimeStatus>
          </div>
        </div>
      </div>
      <div class="bottom flex_row">
        <div class="flex_column">
          <div class="mybox">
            <div class="title">全年碳排放指标</div>
            <div class="box">
              <CarbonEmission></CarbonEmission>
            </div>
          </div>
          <div class="mybox">
            <div class="title">能源优化投入</div>
            <div class="box">
              <EnergyInvestment></EnergyInvestment>
            </div>
          </div>
        </div>
        <div class="flex_column">
          <div class="mybox">
            <div class="title">减排进度及走势</div>
            <div class="box">
              <EmissionReduction></EmissionReduction>
            </div>
          </div>
          <div class="mybox">
            <div class="title">能源优化成效</div>
            <div class="box">
              <EnergyResults></EnergyResults>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right flex_column">
      <div class="mybox">
        <div class="title">能源指标</div>
        <div class="box">
          <EnergyIndex></EnergyIndex>
        </div>
      </div>
      <div class="mybox">
        <div class="title">行业对标</div>
        <div class="box">
          <IndustryBenchmarking></IndustryBenchmarking>
        </div>
      </div>
      <div class="mybox">
        <div class="title">能源损耗</div>
        <div class="box">
          <EnergyConsumption></EnergyConsumption>
        </div>
      </div>
      <div class="mybox">
        <div class="title">投产比</div>
        <div class="box">
          <ProductionRatio></ProductionRatio>
        </div>
      </div>
    </div>
    <!-- <rightcolumn class="app5760 flex_column"/> -->



    <!-- 安全提示弹框 -->
    <el-dialog
      v-dialogDrag
      title="安全提示"
      :close-on-click-modal="false"
      :visible.sync="visible"
      width="40rem"
    >
      <div class="sale-propmt">
        <div class="form">
          <div class="item"><label>事件区域：</label><span>{{ onlyData.area }}</span></div>
          <div class="item"><label>事件时间：</label><span>{{ onlyData.noteTime }}</span></div>
          <div class="item"><label>事件类型：</label><span>{{powerType[onlyData.type]}}</span></div>
          <div class="item"><label>事件内容：</label><span>{{ onlyData.content }}</span></div>
          <!-- <div class="item"><label>事件时间：</label><span>{{ onlyData.noteTime }}</span></div> -->
        </div>
        <!-- <ul>
          <li>
            <span>区域</span>
            <span>{{ onlyData.area }}</span>
          </li>
          <li>
            <span>事件类型</span>
            <span>{{powerType[onlyData.type]}}</span>
          </li>
          <li>
            <span>事件内容</span>
            <span>{{ onlyData.content }}</span>
          </li>
          <li>
            <span>事件时间</span>
            <span>{{ onlyData.noteTime }}</span>
          </li>
        </ul> -->
      </div>
    </el-dialog>

<!-- 重点用能设备弹窗 -->
    <el-dialog v-dialogDrag title="重点用能设备信息" 
      :close-on-click-modal="false" 
      :visible.sync="keyEnergydialog" 
      class="keyEnergydialog">
      <div class="dialogcontent">
        <div class="left">
          <li v-for="(item,index) in forusDevList" :key="index" :class="clickID==item.id?'active':''" @click="importantDevClick(item.id)">{{item.devName}}</li>
        </div>
        <div class="right">
          <div v-if="forusDevList.length==0" style="text-align:center;">暂无设备</div>
          <div v-else>
            <div class="title">【{{importantDetails.devName}}】能耗曲线对比</div>
            <div id="dialogline" ref="dialogline"></div>
            <div class="title">【{{importantDetails.devName}}】基本信息</div>
            <div class="form">
              <div class="img"><img :src="importantDetails.pictures"/></div>
              <div class="text">
                <div class="item"><label>设备名称：</label><span>{{importantDetails.devName}}</span></div>
                <div class="item"><label>设备品牌：</label><span>{{importantDetails.devBrand}}</span></div>
                <div class="item"><label>设备型号：</label><span>{{importantDetails.model}}</span></div>
                <div class="item"><label>安装区域：</label><span>{{importantDetails.area}}</span></div>
                <div class="item"><label>负责人：</label><span>{{importantDetails.linkUser}}</span></div>
                <div class="item"><label>生产日期：</label><span>{{importantDetails.produceDate}}</span></div>
                <div class="item"><label>安装日期：</label><span>{{importantDetails.installDate}}</span></div>
                <div class="item"><label>售后截止：</label><span>{{importantDetails.byDate}}</span></div>
                <div class="item"><label>生产厂商：</label><span>{{importantDetails.customName}}</span></div>
                <div class="item"><label>使用状态：</label><span>{{importantDetails.useStatus==0?"未正常使用":"正常使用"}}</span></div>
                <div class="item"><label>运行状态：</label><span>{{importantDetails.runStatus==0?"关机":"正常"}}</span></div>
                <div class="item"><label>保养周期：</label><span>{{importantDetails.maintain?importantDetails.maintain+'日/次':'--'}}</span></div>
                <div class="item"><label>维保单位：</label><span>{{importantDetails.maintainCompany}}</span></div>
                <div class="item"><label>当前状态：</label><span>{{importantDetails.status==0?"临期":importantDetails.status==1?"正常":importantDetails.status==2?"过期":"未即时保养"}}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>


  </div>
</template>

<script>
let echarts = require('echarts/lib/echarts')
import api from '@/apis/power/power'
import EnergyTrend from "../../components/EnergyTrend";//能源走势
import EnergyStructure from "../../components/EnergyStructure";//能源结构
import KeyEnergyEquipment from "../../components/KeyEnergyEquipment";//重点用能设备
import EnergyInvestment from "../../components/EnergyInvestment";//能源优化投入
import EnergyResults from "../../components/EnergyResults";//能源优化成效
import EmissionReduction from "../../components/EmissionReduction";//减排进度及走势
import CarbonEmission from "../../components/CarbonEmission";//全年碳排放指标
import ProductionRatio from "../../components/ProductionRatio";//投产比
import IndustryBenchmarking from "../../components/IndustryBenchmarking";//行业对标
import EnergyIndex from "../../components/EnergyIndex";//能源指标
import EnergyConsumption from "../../components/EnergyConsumption";//能源损耗
import RealTimeStatus from "../../components/RealTimeStatus";//实时状态

// import leftcolumn from "@/views/CompanyProfile/leftcolumn.vue";
// import rightcolumn from "@/views/EnergyManagement/rightcolumn.vue";

export default {
  components: {
    EnergyTrend,
    EnergyStructure,
    KeyEnergyEquipment,
    EnergyInvestment,
    EnergyResults,
    EmissionReduction,
    CarbonEmission,
    ProductionRatio,
    IndustryBenchmarking,EnergyIndex,EnergyConsumption,RealTimeStatus,
    // leftcolumn,
    // rightcolumn,



  },
  computed:{
    //轴线颜色
    axisLineColor(){
      return this.$store.state.axisLineColor
    },
    //轴文字颜色
    axisLabelColor(){
      return this.$store.state.axisLabelColor
    },
    //网格线属性
    splitLineStyle(){
      return this.$store.state.splitLineStyle
    },
    //图例文字颜色
    legendTextColor(){
      return this.$store.state.legendTextColor
    }
  },
  data() {
    return {
      //组态
      configurationMap:'',//组态图
      iHeight:'',

      openWin:false,

      powerType:['安全提示','管理提示','能耗突增','能耗超标'],
      anquanList:'',
      visible:false,//销售弹出框
      onlyData:'',
      //重点用能设备
      keyEnergydialog:false,//重点设备弹框
      forusDevList:[],//重点设备列表
      clickID:'',//点击事件id
      importantDetails:{
        area: '--', //区域
        byDate: '--', //截至售后日期
        customName: '--', //厂家
        devBrand: '--', //品牌
        devName: '--', //设备名称
        installDate: '--', //安装日期
        linkUser: '--', //负责人
        maintain: '--', //保养周期
        maintainCompany: '--', //维保单位
        model:'--',//设备型号
        pictures: '--', //图片
        produceDate: '--', //生产日期
        runStatus: '--', //运行状态 0关机 1正常
        status: '--', //当前状态 0临期 1正常 2过期 3 未即时保养
        useStatus: '--', //使用状态 0未正常使用 1 正常使用
        type:'-',
      },
    };
  },
  methods: {
    //重点设备列表点击事件
    importantDevClick(id){
      this.clickID = id
      this.getImpDevDetail(id)
    },
    //获取重点设备列表
    getDevList2(){
      api.getImpDevList2().then((res) => {
        if (res.code === 10000) {
          if(res.data){
            this.forusDevList = res.data
            this.clickID = res.data[0].id
            this.getImpDevDetail(res.data[0].id)
          }
        } else {
          this.$message.error(res.message)
          return;
        }
      })
    },
    //获取重点设备详情
    getImpDevDetail(id){
      api.getImpDevDetail(id).then(res=>{
        if(res.code==10000){
          let _baseData = res.data.safeFighting
          let _lineData = JSON.parse(res.data.devEnergy.jsonData)
          let _lastData = []
          let _thisData = []
          //基础数据
          if(_baseData.installDate){
            _baseData.installDate = _baseData.installDate.substring(0,10)
          }
          if(_baseData.produceDate){
            _baseData.produceDate = _baseData.produceDate.substring(0,10)
          }
          if(_baseData.byDate){
            _baseData.byDate = _baseData.byDate.substring(0,10)
          }
          let imgarr =  JSON.parse(_baseData.pictures)
          _baseData.pictures =  imgarr.length?imgarr[0].url:require('@/assets/images/isNoPic.png') 
          this.importantDetails = _baseData
          //折线图数据
          for(var i in _lineData.lastYear){
            _lastData.push(_lineData.lastYear[i].lossPower)
          }
          for(var j in _lineData.nowYear){
            _thisData.push(_lineData.nowYear[j].lossPower)
          }
          
          this.keyEnergyLine(_lastData,_thisData)
          
        }
      })
    },


    //重点设备弹框
    showImportDev(){
      this.keyEnergydialog = true;
      this.getDevList2() //获取重点设备列表
    },

    keyEnergyLine(a,b){
      // let keyEnergyLine = echarts.init( this.$refs.dialogline );
      let keyEnergyLine = echarts.init( document.getElementById('dialogline'));
      keyEnergyLine.setOption({
          tooltip: { trigger: 'axis',textStyle:{fontSize: this.$echartsFontSize},
            axisPointer: {
              type: 'shadow'
            }
            
          },
          legend: {
              data: ['去年', '今年'],
              top:'3%',
              textStyle: {
                  color: this.legendTextColor,fontSize:this.$echartsFontSize
              },
              itemWidth: 15,
              itemHeight: 5,
          },
          xAxis: {
              type: 'category',
              axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize,interval: 0},
              axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
              axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true},
              data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
          },
          yAxis: {
            name:'单位(折标煤/吨)',
            nameTextStyle:{color:this.axisLabelColor,fontSize:this.$echartsFontSize-6},
            axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
            axisLine:{show:true,lineStyle:{color:this.axisLineColor}},
            // splitNumber:5, 
            nameGap:this.$echartsFontSize,
            splitLine:{show:true,lineStyle:this.splitLineStyle},
            axisTick: { show: true ,lineStyle:{color:this.axisLineColor}},
          },
          grid: { left: '4%',right:'4%',top:'22%',bottom:'4%',containLabel: true},
          series: [
            {
              name: '去年',             
              type: 'line', showSymbol:false,smooth:true,
              itemStyle: {
                  normal: {
                      color: '#00ccff',
                      lineStyle: {
                          color: "#00ccff",
                          width: 4
                      },
                  }
              },
              data:a
            },
            {
              name: '今年',
              type: 'line',showSymbol:false,smooth:true,
              itemStyle: {
                  normal: {
                      color: '#24ffb1',
                      lineStyle: {
                          color: "#24ffb1",
                          width: 4
                      },
                  }
              },
              data:b
            },
          ]
      })
    },


    //获取实时状态
    getZuTai(){
      api.getConf().then(res=>{
        if(res.code==10000){
          if (res.data.list.length) {
            this.configurationMap = res.data.list[0].confUrl
          }
        }
      })
    },
    //安全提示
    getSaveList(){
      api.getSafaty().then(res=>{
        if(res.code==10000){
          let _data = res.data.list
          let _arr = _data.map(item=>{
            return{
              id:item.id,
              type:this.powerType[item.type],
              name:item.area,
              time:item.noteTime,
            }
          })
          this.anquanList = _arr
        }
      })
    },
    //安全提示弹框
    pointClick(id){
      this.visible = !this.visible
      api.getSafatyInfo(id).then(res=>{
        if(res.code==10000){
          this.onlyData = res.data
        }
      })
    },
  },
  mounted() {
    //获取高度
    var _iHeight = this.$refs.iframeHeightPower.offsetHeight
    this.iHeight = _iHeight


    // var _that = this;
    //iframe监听
    // window.addEventListener('message', function(e) {
    //   if(e.origin!='http://'+window.location.host){
    //     _that.deviceId = e.data
    //     _that.openWin = !_that.openWin;
    //   }
    // },false);


    this.getSaveList()
    this.getZuTai()
  },
};
</script>


<style lang="less">
.el-popover{
  padding: 0;
  border: none;
  background: rgb(38, 63, 226);
}

.keyEnergydialog .el-dialog{ width: 65rem;
    .dialogcontent{ display: flex; flex-direction: row; padding:.5rem; height: 35rem; overflow: hidden;
      .left{ width: 12rem; flex-shrink: 0; font-size: .8rem; border: #3570ff solid 1px; padding:.5rem; margin-right: 1rem; height: 100%; overflow-y: auto;
        li{ height: 1.8rem; color: #fff; padding:0 .5rem; line-height: 1.8rem; cursor: pointer; margin-bottom: .2rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;}
        li.active{ color: #24ffb1; background: rgba(24, 255, 106, .1); border: #24ffb1 dashed 1px;}
        li:hover{ color: #24ffb1;}
      }
      .right{ flex: 1; width: 100%; overflow: hidden; display: flex; flex-direction: column;
        .title{ color: #24ffb1; font-size: .8rem; line-height: 2rem; margin-bottom: .5rem;}
        #dialogline{ width: 100%; height: 12rem;}
        .form{ flex: 1; width: 100%; display: flex; flex-direction: row; overflow: hidden;
          .img{ width: 11rem; margin-right: 1rem; flex-shrink: 0;
            img{ width: 100%;}
          }
          .text{ flex: 1; overflow-y: auto; display: flex; flex-direction: row; flex-wrap: wrap; align-content: flex-start;
            .item{ border-bottom: #555e86 dashed 1px; font-size: .8rem; height: 2rem; line-height: 2rem; width: 50%; display:flex; flex-direction: row;
              label{ width: 5rem; flex-shrink: 0; text-align: right; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 10px;}
              span{ color: #fff;}
            }
          }
        }
      }
    }
  }
</style>
<style lang="less" scoped>
.point-save{
  background:transparent;
  color:#fff;
  border:1px solid #fff;
  >li>span:first-child{
    display: inline-block;
    text-align: center;
    width: 30%;
    padding: 0.5rem;
    background: rgb(7,28,169)
  }
  >li>span:last-child{
    display: inline-block;
    padding-left: 0.4rem;
    width: 70%;
  }
}
.emhome {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0 0.5rem 0.5rem;
  & > .left {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      height: 25%;
      overflow: hidden;
    }
  }
  & > .center {
    height: 100%;
    overflow: hidden;
    width: 50%;
    & > .top,
    & > .bottom {
      height: 50%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      & > .flex_column {
        width: 50%;
        height: 100%;
        overflow: hidden;
        .mybox {
          flex: 1;
          height: 50%;
          overflow: hidden;
        }
      }
    }
  }
  & > .right {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      height: 25%;
      overflow: hidden;
    }
  }

  .anquanlist{  flex-direction: column; margin:0.6rem;
    li{ flex: 1; padding:0px 0.4rem;height:20%; width: 100%; display: flex; flex-direction: row; align-items: center;
      i{ color: #f4af1b; position: relative; top:1px; margin-right: 10px; font-size: .9rem;}
      span{ text-overflow:ellipsis; white-space: nowrap; overflow: hidden;}
      span:nth-child(2){ flex:1;}
      span:nth-child(3){ width: 5.5rem; text-align: center;}
      span:nth-child(4){ width: 7.5rem; text-align: center;}
    }
    li:nth-child(odd){ background: #ffffff10;}
    li:hover{
      // text-decoration: underline;
      cursor: pointer;
    }
  }
  .realtime{ position: relative;}

}
.sale-propmt {
  .form{ flex: 1; width: 100%; display: flex; flex-direction: column; overflow: hidden; padding:0 1rem 1rem; font-size: 0.8rem; 
    .item{ border-bottom: #555e86 dashed 1px; padding:.4rem .5rem; display:flex; flex-direction: row;
      label{ width: 5rem; flex-shrink: 0; text-align: right; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 10px;}
      span{ color: #fff;}
    }
  }
  // > ul > li > span:first-child {
  //   width: 30%;
  //   display: inline-block;
  //   padding: 0.8rem 1.5rem;
  //   border: 1px solid #fff;
  // }
  // > ul > li > span:last-child {
  //   width: 70%;
  //   display: inline-block;
  //   padding: 0.8rem 1.5rem;
  //   border: 1px solid #fff;
  // }
}

.imgbox{position: relative;}
.imgbox img{ width: 100%; height: 100%;}
.imgbox .noimg{ position: absolute; top:50%; left:50%; margin-top:-221px; margin-left:-198px; width: 398px; height: 442px; transform: scale(.5);}
</style>
